import React from 'react';
import {
  TipsMapFunType,
  TipsMapType,
  communityFollowersTipsText,
} from '../index';

export const channelCardText: TipsMapType = {
  space: 0,
  sort: ['en'],
  en: 'Accounts that did not post during the selected date range are also included.',
};

export const accountsChannelCardText: TipsMapType = {
  en: 'Including all the monitor accounts under the channel, accounts that did not post during the selected date range are also included.',
  zh: '包括该渠道下所有监控官号，无论所选时段官号是否发帖。',
};

export const accountsFollowersTipsText: TipsMapType =
  communityFollowersTipsText;

export const accountsGrowthOfFollowersText: TipsMapType = {
  zh: (
    <>
      粉丝增长量：通过本期区间减去上期区间的数据获得差值，负数代表粉丝量下降，正数代表粉丝量上涨。{' '}
      <br />
      各平台的 Followers 取值：Reddit 取自 Members，Youtube 取自
      Subscribe，其他平台取自Followers。
    </>
  ),
  en: (
    <>
      Followers difference of adjacent intervals: The difference is obtained by
      subtracting the data of the previous interval from the current interval.
      Negative numbers represent declines and positive numbers represent
      increases.
      <br />
      Followers' source of each platform: Reddit is taken from Members, Youtube
      is taken from Subscribe, and other platforms are taken from Followers.
    </>
  ),
};

export const accountsPublishingPerformanceTipsText: TipsMapType = {
  en: (
    <>
      Shows how the post performed after it was published. Data on Engagements,
      likes, comments, shares, and views of posts published on that day were
      collected based on the date of Posting. That is, the post published
      yesterday, today updated the post's number of likes, and the number of
      likes will be counted in yesterday's data.
    </>
  ),
  zh: (
    <>
      显示帖子发布后的表现情况。以帖子发布日期为基准，统计当天发布的帖子的互动、点赞、评论、分享、观看数据。即，昨天发布的帖子，今天更新该贴点赞数后，点赞数将统计在昨天数据中
    </>
  ),
};

export const accountsAudiencePerformanceTipsText: TipsMapType = {
  en: (
    <>
      Displays audience feedback on the post. Based on the actual increase of
      data every day, calculate the daily increase of interaction, likes,
      comments, shares, and viewing data of posts. That is, the number of new
      "likes" of today's posts will be counted in today's data.
    </>
  ),
  zh: (
    <>
      显示观众针对帖子的互动情况。以每天实际增加的数据为基准，统计帖子每天新增的互动、点赞、评论、分享、观看数据。即，今天该贴新增的点赞数，将统计在今天的数据中。
    </>
  ),
};

export const accountsTopTipsText: TipsMapFunType = (
  text1,
  text2,
): TipsMapType => ({
  en: <>The account name of opinions: {text1}</>,
  zh: <>舆情系统官号命名：{text1}</>,
});

export const accountsTipsText: TipsMapType = {
  en: (
    <>
      There is a delay in data updating, so the data on this page (such as
      views, interactions, likes, shares, comments, followers, etc.) are not
      realtime data.
      <br />
      Account followers data was updated from February 6, 2023.
    </>
  ),
  zh: (
    <>
      数据更新存在延时，所以本页数据（例如观看、互动量、点赞、分享、评论、关注等）非实时数据。
      <br />
      官号粉丝数据从2023-02-06开始更新。
    </>
  ),
};

export const accountGuideTips = {
  en: 'No data under current selections',
  zh: '当前筛选条件下无数据',
};
